import themeAssetgameCategoryIcHotSvg from '@theme/game/category/ic_hot.svg'
import themeAssetgameCategoryIcVideoSvg from '@theme/game/category/ic_video.svg'
import themeAssetgameCategoryIcSlotSvg from '@theme/game/category/ic_slot.svg'
import themeAssetgameCategoryIcPokerSvg from '@theme/game/category/ic_poker.svg'
import themeAssetgameCategoryIcFishSvg from '@theme/game/category/ic_fish.svg'
import themeAssetgameCategoryIcLotterySvg from '@theme/game/category/ic_lottery.svg'
import themeAssetgameCategoryIcSportsSvg from '@theme/game/category/ic_sports.svg'

export const GAME_PAYMENT_METHODS: Record<string, any> = {
  alipay: { id: 'alipay', name: '支付宝', icon: 'account/icon-alipay.png' },
  debit: { id: 'debit', name: '银行卡', icon: 'account/icon-creditcard.png', withNameField: true, nameRequired: true },
  unionpay: { id: 'unionpay', name: '云闪付', icon: 'account/icon-ysf.png' },
  wechat: { id: 'wechat', name: '微信支付', icon: 'account/icon-wechat.png' },
  808: { id: '808', name: '808支付', withNameField: true, nameRequired: true },
  selfdebit: { id: 'selfdebit', name: '银行转帐', icon: 'account/icon-transfer.png' },
  selfusdt: { id: 'selfusdt', name: 'USDT', icon: 'account/icon-usdt.png' },
  obankbank: {
    id: 'obankbank',
    name: '赚钱宝(银)',
    icon: 'account/icon-obankbank.png',
    withBankField: true,
    nameRequired: true,
    accountRequired: true,
    hidden: true,
  },
  obankalipay: {
    id: 'obankalipay',
    name: '赚钱宝(支)',
    icon: 'account/icon-obankalipay.png',
    withNameField: true,
    withAccountField: true,
    nameRequired: true,
    accountRequired: true,
    hidden: true,
  },
}

export const getPaymentMethod = function (code: any): any {
  code = typeof code === 'string' ? code.toLowerCase() : ''
  return GAME_PAYMENT_METHODS[code]
}

export const GAME_PAYMENT_METHOD_KEYS = {
  SELF_DEBIT: 'selfdebit',
  SELF_USDT: 'selfusdt',
  OBANK_BANK: 'obankbank',
  OBANK_ALIPAY: 'obankalipay',
}

export const GAME_DEPOSIT_CHANNEL_PROMOTE_FLAG = {
  PROMOTED: '1',
  HOT: '2',
}

export const GAME_CATEGORY_LIST = [
  {
    name: '热门',
    icon: themeAssetgameCategoryIcHotSvg,
    filter: {
      tagId: 2, // 热门
    },
  },
  {
    name: '视讯',
    icon: themeAssetgameCategoryIcVideoSvg,
    filter: {
      gameType: 2,
    },
  },
  {
    name: '电子',
    icon: themeAssetgameCategoryIcSlotSvg,
    filter: {
      gameType: 4,
    },
  },
  {
    name: '棋牌',
    icon: themeAssetgameCategoryIcPokerSvg,
    filter: {
      gameType: 3,
    },
  },
  {
    name: '捕鱼',
    icon: themeAssetgameCategoryIcFishSvg,
    filter: {
      gameType: 1,
    },
  },
  {
    name: '彩票',
    icon: themeAssetgameCategoryIcLotterySvg,
    filter: {
      gameType: 6,
    },
  },
  {
    name: '体育',
    icon: themeAssetgameCategoryIcSportsSvg,
    filter: {
      gameType: 5,
    },
  },
]

export const GAME_MESSAGE = {
  NOT_RELEASE: '敬请期待',
  BAN_NOTICE: '会员已锁定，请联系客服',
  IP_BAN_NOTICE: '您的装置系统侦测为异常危险用户，已封禁您使用，如有疑问，请联系客服咨询',
  VERSION_TOO_LOW:
    '尊敬的用户：由于系统侦测到ID异常，请将描述档移除后重新下载安装；若账户有余额，请联系在线客服协助找回，谢谢！',
}
